export const endpoints = {
  GET_PLACES: '/api/public/places',
};
